/**
 * @generated SignedSource<<5e52524ed8f1f27022e46b48ac45ac70>>
 * @relayHash 529fd8532057d1ab7f7824960922aace
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 529fd8532057d1ab7f7824960922aace

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Data",
    "kind": "LinkedField",
    "name": "data",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Center",
        "kind": "LinkedField",
        "name": "managementCenters",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FindQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FindQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "529fd8532057d1ab7f7824960922aace",
    "metadata": {},
    "name": "FindQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "93799ac14e230e5dbdb821700c5b3979";

export default node;
